import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export type RiskLevel = 'NORMAL' | 'HIGH';
export type ViolationType = 'DISPARITY_FLAG' | 'AI_GENERATED' | 'SUSPECTED_FORGERY';

export interface WatchlistUser {
  userId: string;
  email: string;
  displayName: string | null;
  riskLevel: RiskLevel;
  /** Score di fiducia 0-100 (100 = affidabile, basso = sospetto) */
  trustScore: number;
  /** N. eventi sospetti negli ultimi 30 giorni */
  suspiciousCount30d: number;
  lastEventAt: string;
}

export interface WatchlistEvent {
  id: string;
  userId: string;
  userEmail: string;
  type: ViolationType;
  reason: string | null;
  receiptId: string | null;
  createdAt: string;
}

export interface WatchlistResponse {
  counts: {
    flaggedUsers: number;
    recentEvents: number;
  };
  flaggedUsers: WatchlistUser[];
  recentEvents: WatchlistEvent[];
}

/** Chiave React Query — esportata per invalidazione e accesso sidebar. */
export const WATCHLIST_QK = ['watchlist'] as const;

/**
 * Hook React Query per `GET /receipts/admin/watchlist`.
 * Usato sia nella WatchlistPage sia nel badge di navigazione (Layout).
 */
export function useWatchlist() {
  return useQuery({
    queryKey: WATCHLIST_QK,
    queryFn: async () => {
      const res = await apiClient.get<WatchlistResponse>('/receipts/admin/watchlist');
      return res.data;
    },
    // Aggiorna il badge ogni volta che l'admin torna alla finestra
    refetchOnWindowFocus: true,
    // Dati considerati freschi per 60s — evita refetch superflui navigando tra pagine
    staleTime: 60_000,
  });
}
